import styled from "styled-components";

export const TabBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 5rem;
  padding: 0.5rem;
  background-color: var(--very-dark-blue);

  .button {
    background-color: var(--very-dark-blue);
    color: var(--white);
    position: relative;
    height: 100%;
    width: 5rem;
  }


  .button.active {
    box-shadow: 0px 0px 8px rgba(0,0,0,0.1);

    img {
      filter: invert(26%) sepia(85%) saturate(1867%) hue-rotate(182deg) brightness(95%) contrast(95%);
    }
  }

  @media (max-width: 768px) {
    justify-content: space-around;

    .button {
      background-color: var(--very-dark-blue);
      color: var(--white);
    }

    .button.active {
      box-shadow: 0px 0px 8px rgba(0,0,0,0.1);

      img {
        filter: invert(26%) sepia(85%) saturate(1867%) hue-rotate(182deg) brightness(95%) contrast(95%);
      }
    }
  }
`;